var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "layout",
    { attrs: { breadcrumbs: _vm.breadcrumbs } },
    [
      _c("template", { slot: "header" }, [
        _c("h1", { staticClass: "text-center" }, [
          _vm._v("\n            Select Make & Model\n        ")
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "d-sm-none mobile-header" },
        [
          _c("b-col", [
            _vm.selectedFragment === "make"
              ? _c("h1", { staticClass: "text-center" }, [
                  _vm._v("\n                Select Make\n            ")
                ])
              : _vm.selectedFragment === "model"
              ? _c("h1", { staticClass: "text-center" }, [
                  _vm._v("\n                Select Model\n            ")
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { attrs: { id: "shop-by-make" } },
        [
          _vm.showMakes
            ? _c(
                "b-col",
                { staticClass: "make-column", attrs: { cols: "12", md: "3" } },
                [
                  _c(
                    "b-form-select",
                    {
                      model: {
                        value: _vm.category,
                        callback: function($$v) {
                          _vm.category = $$v
                        },
                        expression: "category"
                      }
                    },
                    [
                      _c("option", { attrs: { value: "all" } }, [
                        _vm._v("\n                    All\n                ")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "american" } }, [
                        _vm._v(
                          "\n                    American\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "asian" } }, [
                        _vm._v("\n                    Asian\n                ")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "european" } }, [
                        _vm._v(
                          "\n                    European\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "luxury" } }, [
                        _vm._v("\n                    Luxury\n                ")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.availableMakes, function(make) {
                    return _c(
                      "div",
                      {
                        key: make.id,
                        staticClass:
                          "make-block d-flex justify-content-between align-items-center my-3",
                        on: {
                          click: function($event) {
                            return _vm.onMakeSelect(make)
                          }
                        }
                      },
                      [
                        _c("make-icon", {
                          attrs: {
                            make: make,
                            selected: _vm.isMakeSelected(make)
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showModels
            ? _c("b-col", { attrs: { cols: "12", md: "9" } }, [
                _vm.selectedMakeName
                  ? _c("div", { staticClass: "h-100" }, [
                      _vm.isLoading
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column h-100 justify-content-center text-center"
                            },
                            [
                              _c("loading-spinner", {
                                staticClass: "mr-auto ml-auto",
                                attrs: { size: 60 }
                              })
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _vm.yearOptions != null &&
                              _vm.yearOptions.length > 1
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex my-1 my-sm-0 justify-content-between justify-content-md-end"
                                    },
                                    [
                                      _vm.selectedMakeName
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-md-none make-header d-flex mb-0 justify-content-center flex-column"
                                            },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _vm._v(
                                                    "\n                                " +
                                                      _vm._s(
                                                        _vm.selectedMakeName
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                  _c(
                                                    "b-link",
                                                    {
                                                      on: {
                                                        click: _vm.backToMakes
                                                      }
                                                    },
                                                    [
                                                      _c("small", [
                                                        _vm._v("(change)")
                                                      ])
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("year-selector", {
                                        attrs: { options: _vm.yearOptions },
                                        on: { change: _vm.changeYear },
                                        model: {
                                          value: _vm.selectedYear,
                                          callback: function($$v) {
                                            _vm.selectedYear = $$v
                                          },
                                          expression: "selectedYear"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.bodyTypes, function(bodyType) {
                                return _c("div", { key: bodyType.name }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "body-style-header position-relative"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ico-block d-flex flex-column text-center position-absolute"
                                        },
                                        [
                                          _c("body-style-icon", {
                                            staticClass: "d-none d-sm-block",
                                            attrs: { id: bodyType.name }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "body-style-title" },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm._f("toUpper")(
                                                      bodyType.name
                                                    )
                                                  ) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "model-block d-flex justify-content-start flex-wrap"
                                    },
                                    _vm._l(bodyType.models, function(model) {
                                      return _c(
                                        "div",
                                        {
                                          key: model.id,
                                          staticClass:
                                            "d-flex flex-column justify-content-center align-items-center p-2 model",
                                          on: {
                                            click: function($event) {
                                              return _vm.onModelSelect(model)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "model-wrapper d-block flex-column justify-content-center"
                                            },
                                            [
                                              model.profileImageUrl
                                                ? _c("b-img", {
                                                    attrs: {
                                                      src:
                                                        model.profileImageUrl,
                                                      fluid: ""
                                                    }
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "missing-image-wrapper h-100 d-flex justify-content-center align-items-center"
                                                    },
                                                    [
                                                      _c("body-style-icon", {
                                                        attrs: {
                                                          id: _vm.bodyStyleOrDefault(
                                                            model
                                                          )
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-column justify-content-center align-items-center text-block"
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "model-name" },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(model.name) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "model-price" },
                                                [
                                                  _vm._v(
                                                    "\n                                        starting at\n                                        " +
                                                      _vm._s(
                                                        _vm._f("numeral")(
                                                          model.msrp,
                                                          "$0,0"
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ])
                              })
                            ],
                            2
                          )
                    ])
                  : _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column h-100 text-center select-make"
                      },
                      [_c("h3", [_vm._v("Please select a Make")])]
                    )
              ])
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }